import { useState } from "react";
import { Alert } from "react-bootstrap";

export function AlertDismissible(props) {
  const [show, setShow] = useState(true);

  if (!show) {
    return null;
  }

  return (
    <Alert {...props} onClose={() => setShow(false)} dismissible>
      {props.children}
    </Alert>
  )
}

export default AlertDismissible;